import * as ko from "knockout";
import * as _ from "underscore";
import * as fetchGoogleMaps from "fetch-google-maps";
import { App } from "../../app";
import { Api } from "../../app-api";
import * as m from "./register-models";
import { ViewModel as root } from "../register";

const divMapContainer: HTMLDivElement = document.querySelector("#map-container");
const inputLookup: HTMLInputElement = <HTMLInputElement>document.querySelector("#pac-input");

const $tabLocationsMap: JQuery<HTMLElement> = $("a[href='#locations-map']");

export class ChooseLocations extends m.Form {
    apiKey: string;
    place_id: string;

    //bounds: google.maps.LatLngBounds;
    map: google.maps.Map;
    marker: google.maps.Marker;

    bounds = ko.observable<google.maps.LatLngBounds>();
    displayLocations = ko.observable(false);
    googlePlace = ko.observable<google.maps.places.PlaceResult>();
    springBreakOnly = ko.observable(false);

    locations = ko.observableArray<m.Site>();

    filteredActivities: ko.Computed<m.Activity[]>;
    filteredLocations: ko.Computed<m.Site[]>;

    country: ko.PureComputed<string>;
    springBreak: ko.PureComputed<boolean>;

    clearSearch: () => void;
    showSpringBreakOnly: () => void;

    constructor(model: any, private root: root) {
        super(root);
        let self = this;

        self.id = m.FormEnum.Locations;
        self.heading = "Choose a location";

        self.apiKey = model.apiKey;
        self.place_id = model.place;

        self.filled(new m.Filled("Locations"));

        self.filled().display = ko.pureComputed(() => {
            return _(root.selectedLocations()).any();
        }, self);

        self.filled().summary = ko.pureComputed(() => {
            if (!self.filled().display) { return ""; }
            return _(root.selectedLocations()).pluck("name").join(", ");
        }, self);

        self.filteredActivities = ko.computed(() => {
            return _.chain(self.locations())
                .map(x => x.activities)
                .flatten()
                .unique(x => x, "id")
                .value();
        }, self);

        self.filteredLocations = ko.computed(() => {
            // this causes distance to sort as string
            //.sortBy(x => [_(x.locations).any(y => y.springBreak) ? 0 : 1, x.distance.value])

            //_(self.locations()).each(x => console.log('location: ' + x.id + ' ' + x.enabled()));

            return _.chain(self.locations())
                .filter(x => x.enabled())
                //sort by least important key
                .sortBy(x => x.distance.value)
                //sort again on the more important key
                //.sortBy(x => _(x.locations).any(y => y.springBreak) ? 0 : 1)
                .value();
        }, self);

        self.country = ko.pureComputed(() => {
            return _(self.locations()).any() ? self.locations()[0].country : null;
        }, self);

        self.springBreak = ko.pureComputed(() => {
            return _(self.locations()).any(x => _(x.locations).any(y => y.springBreak));
        }, self);

        self.next().enabled = ko.pureComputed(() => {
            return _(root.selectedLocations()).any() && root.validRegion();
        }, self);

        self.next().selected = ko.pureComputed(() => {
            return _(root.selectedLocations()).any() ? root.selectedLocations().length : 0;
        }, self);

        self.bounds.subscribe(newVal => {
            //console.log('self.bounds.subscribe');
            //console.log(newVal);
            self.resizeMap();
        })
        self.busy.subscribe(newVal => {
            App.busy(newVal);
            self.noResults(newVal ? false : !_(self.locations()).any());
        });

        self.filteredLocations.subscribe(changes => {
            self.showing().showing(changes.length);
        });

        self.googlePlace.subscribe(() => {
            self.placeChanged();
        });

        self.locations.subscribe(changes => {
            self.showing().of(changes.length);
        });

        root.selectedActivities.subscribe(changes => {
            const activities = _(changes).any() ? changes : self.filteredActivities();

            _(self.locations()).each(x => {
                x.displayInfo(false);
                const val = _(activities).map(x => x.id);
                x.enable(val);
            });
        });

        self.active.subscribe(newVal => {
            if (newVal && App.empty(self.map))
                _.delay(() => self.initMaps(), 100);
        });

        self.filteredActivities.subscribe(changes => {
            const val = _(changes).map(x => x.id);
            _(self.locations()).each(x => x.enable(val));
        });

        self.locations.subscribe(changes => {
            const any = _(changes).any();

            if (!any) {
                root.selectedActivities.removeAll();
                root.selectedLocations.removeAll();
            }
            else {
                //console.log('locations.subscribe');
                //console.log(self.bounds());
                let bounds = self.bounds() || new google.maps.LatLngBounds();
                _(changes).each(x => {
                    bounds.extend({ lat: x.lat, lng: x.lng });
                });

                self.bounds(bounds);
            }

            self.displayLocations(any);
        });

        //self.springBreakOnly.subscribe(newVal => {
        //    console.log(newVal);
        //});

        self.back = () => {
            return;
        }

        self.clearSearch = () => {
            inputLookup.value = "";
            inputLookup.focus();
            self.locations.removeAll();
        }

        self.showSpringBreakOnly = () => {
            //console.log('showSpringBreakOnly');
            self.springBreakOnly(!self.springBreakOnly());
        }

        self.filled().show = () => {
            self.show();
        }

        self.next().next = () => {
            if (!self.next().enabled()) { return false; }
            root.chooseSkillLevels().show();
        }

        App.onEnter("#locationsSection .list-container", self.next().next);

        //$tabLocationsMap.on("shown.bs.tab", () => self.resizeMap());
    }

    private getLocations(data: any) {
        let self = this;
        //console.log('getLocations');
        //console.log(JSON.stringify(data));

        self.busy(true);

        //self.locations([]);
        self.locations.removeAll();

        Api.GetLocations(data)
            .done(results => {
                //if (Api.NoResults("No Location Results", results)) { return; }

                let temp = self.locations();

                _(results.sites).each(x => {
                    let val = new m.Site(x, self.map, self.root);
                    temp.push(val);
                });

                self.locations.valueHasMutated();         
            })
            .always(() => self.busy(false));
    }

    private handleLocationError() {
        console.log("geolocation error");
    }

    // use Maps as 'any' to workaround missing @types
    private initLookup(Maps: any) {
        let self = this;
        //console.log('initLookup');

        let service = new Maps.places.Autocomplete(inputLookup);
        service.bindTo('bounds', self.map);
        service.setComponentRestrictions({ 'country': ['us', 'ca'] });
        service.setFields(['geometry', 'place_id']);

        service.addListener('place_changed', () => {

            let place = service.getPlace();

            if (App.empty(place.place_id)) {
                // user entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                window.alert("No details available for input: '" + inputLookup.value + "'");
                return;
            }

            self.googlePlace(place);
        });
    }

    private initMaps() {
        let self = this;
        //console.log('initMaps');

        fetchGoogleMaps({
            apiKey: self.apiKey,
            language: "en",
            libraries: ["places"]
        }).then((Maps) => self.newMap(Maps));
    }

    private newMap(Maps: any) {
        let self = this;
        //console.log('newMap');

        self.map = new google.maps.Map(divMapContainer, {
            zoom: 11,
            center: new google.maps.LatLng(49.255, -123.157),
            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP]
            },
            mapTypeControl: true,
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });

        self.marker = new Maps.Marker({
            map: self.map
        });

        self.initLookup(Maps);

        if (App.hasVal(self.place_id))
            self.placeSearched(Maps);
        else
            self.geoLocate();
    }

    private geoLocate() {
        let self = this;
        //console.log('geoLocate');

        // try HTML5 geolocation.
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                let pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                self.map.setCenter(pos);
                self.map.setZoom(11);
                self.marker.setPosition(pos);
            }, () => self.handleLocationError());
        }
    }

    private placeChanged() {
        let self = this;
        //console.log('placeChanged');

        let geometry = self.googlePlace().geometry;
        //console.log(geometry.viewport);
        self.bounds(geometry.viewport);
        //console.log(self.bounds());

        let location = geometry.location;
        self.map.setCenter(location);
        self.marker.setPosition(location);

        let data = {
            lat: location.lat(),
            lng: location.lng()
        }

        self.getLocations(data);
    }

    private placeSearched(Maps: any) {
        let self = this;
        //console.log('placeSearched');

        let service = new Maps.places.PlacesService(self.map);

        service.getDetails({
            placeId: self.place_id,
            fields: ['geometry', 'name']
        }, (place, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                self.googlePlace(place);
            }
        });
    }

    private resizeMap() {
        let self = this;
        //console.log('resizeMap');

        self.map.fitBounds(self.bounds());
        self.map.panToBounds(self.bounds());
        //self.map.setCenter(pos);
        self.map.setZoom(11);
    }
}